import { create } from 'zustand';

// https://zustand.docs.pmnd.rs/guides/updating-state
type State = {
    finalCanvasUrl: string;
    originalCanvasUrl: string;
};

type Action = {
    setFinalCanvasUrl: (firstName: State['finalCanvasUrl']) => void;
    setOriginalCanvasUrl: (lastName: State['originalCanvasUrl']) => void;
};

export const useImageEnhancerEditorInfoStore = create<State & Action>((set) => ({
    finalCanvasUrl: '',
    originalCanvasUrl: '',
    setFinalCanvasUrl: (finalCanvasUrl) =>
        set((state) => ({ finalCanvasUrl: finalCanvasUrl })),
    setOriginalCanvasUrl: (originalCanvasUrl) =>
        set((state) => ({ originalCanvasUrl: originalCanvasUrl })),
}));
